/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Related_GuideInputs */

const en_directory_api_reference_related_guide = /** @type {(inputs: Directory_Api_Reference_Related_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent guide`)
};

const zh_directory_api_reference_related_guide = /** @type {(inputs: Directory_Api_Reference_Related_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 指引`)
};

/**
* | output |
* | --- |
* | "Agent guide" |
*
* @param {Directory_Api_Reference_Related_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_related_guide = /** @type {((inputs?: Directory_Api_Reference_Related_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Related_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_related_guide(inputs)
	return zh_directory_api_reference_related_guide(inputs)
});
export { directory_api_reference_related_guide as "directory.api_reference.related_guide" }